<template>
  <div class="parts--supplier-quotes__statistics">
    <filters
      :model.sync="formFilter"
      @on-filter="changeFilter"
    ></filters>
    <div class="row">
      <div class="col-xl-6 col-12">
        <chart-bar
          ref="chart-bar"
          class="parts--supplier-quotes__layout-item"
          :data="dataChart"
          :columns="columns"
          :labels="labels"
          :options="options"
        ></chart-bar>
      </div>
      <div class="col-xl-6 col-12">
        <grid ref="grid" :config="gridConfig"/>
      </div>
    </div>
  </div>
</template>
<script>
import gridConfig from './GridConfig'
import { waitValue } from '@/utils/promises'
import { api } from '@/services/api'
import * as dynamic from '@/utils/dynamic'

export default {
  name: 'LayoutStatistics',
  components: {
    'chart-bar': () => import(/* webpackChunkName: 'Chart' */ '@/components/Chart/Bar'),
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'filters': () => import(/* webpackChunkName: 'Grid' */ './Filters')
  },
  props: {
    partID: { required: true },
    editorID: { required: true }
  },
  watch: {
    'partID': {
      immediate: true,
      handler: 'loadData'
    }
  },
  data () {
    return {
      gridConfig: gridConfig,
      columns: [],
      formFilter: {
        conditionID: [23, 3, 2]
      },
      tryRenderIndex: null,
      options: {
        responsive: true,
        maintainAspectRatio: false
      },
      labels: [],
      dataChart: []
    }
  },
  computed: {
    queryOptionFilter () {
      return dynamic.mergeFilters(
        dynamic.makeFilter('partID', this.partID, dynamic.equals),
        dynamic.makeFilter('conditionID', this.formFilter.conditionID, dynamic.decoratorValueArray(dynamic.equals))
      ).join('&&')
    }
  },
  methods: {
    getGrid () {
      return waitValue(() => this.$refs.grid)
    },
    getChart () {
      let maxWaitTime = 20000
      return waitValue(() => this.$refs['chart-bar'], maxWaitTime)
    },
    changeFilter () {
      this.loadData()
    },
    loadData () {
      if (this.partID) {
        this.loadDataChart()
      }
    },
    /**
     * @desc Load data for chart
     * @returns {AxiosPromise<any>}
     */
    async loadDataChart () {
      const params = {
        'filter': this.queryOptionFilter
      }
      const grid = await this.getGrid()
      grid.setLoading(true)

      try {
        const { data: { value } } = await api.get(`Statistics/GetAllStatisticsRFQ2`, { params })

        const columns = value.map(({ conditionTitle }) => ({
          key: conditionTitle,
          label: conditionTitle
        }))
        this.columns = Array.from(new Map(columns.map((column) => [column.key, column])).values())

        const labels = value.map(({ entryDateYear }) => entryDateYear).sort()
        this.labels = Array.from(new Set(labels).keys())

        const dataMap = value.reduce((acc, item) => {
          const key = `${item.entryDateYear}--${item.conditionTitle}`
          if (!acc[key]) {
            acc[key] = []
          }
          acc[key].push(item)
          return acc
        }, {})

        this.dataChart = Object.values(dataMap)
          .map((items) => {
            const item = items[0]
            return {
              x: item.entryDateYear,
              y: items.reduce((acc, { avgDollarPrice }) => acc + avgDollarPrice, 0),
              columnKey: item.conditionTitle
            }
          })

        grid.setData(value)

        this.tryRenderChart()
      } catch (e) {
        console.error(e)
      } finally {
        grid.setLoading(false)
      }
    },
    tryRenderChart () {
      this.getChart()
        .then((chart) => {
          chart.render()
        })
    }
  }
}
</script>
<style lang="stylus">
  .parts--supplier-quotes__layout-item{
    margin-top 3rem
  }
</style>
